import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import {colors} from "./theme.js";
export default function InputSlider(props) {
  const {
    value,
    defaultValue,
    onChange,
    name,
    min,
    max,
    step,
    ...rest
  } = props;
  return /* @__PURE__ */ React.createElement(Input, {
    type: "range",
    value,
    defaultValue,
    onChange,
    min,
    max,
    step,
    ...rest
  });
}
const Input = styled.input`
  height: 25px;
  width: 100%;
  appearance: none;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 2px;
    cursor: pointer;
    box-shadow: 0px 0px 0px ${colors.b};
    background: ${colors.b5};
    border: 2px solid ${colors.b5};
  }

  &::-webkit-slider-thumb {
    height: 20px;
    width: 20px;
    background: white;
    border-radius: 30px;
    border: 2px solid ${colors.b5};
    appearance: none;
    margin-top: -10px;
  }

  &::-moz-range-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    animate: 0.2s;
    box-shadow: 0px 0px 0px ${colors.b5}, 0px 0px 0px ${colors.b5};
    background: ${colors.b5};
    border: 0px solid ${colors.b5};
  }

  &::-moz-range-thumb {
    height: 20px;
    width: 20px;
    background: white;
    border-radius: 30px;
    border: 1px solid ${colors.b5};
    appearance: none;
    margin-top: -10px;
  }
`;
